// extracted by mini-css-extract-plugin
export default {"box":"OurAim_box__vvI1+","aim":"OurAim_aim__CZmVS"};